import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import ProductDetailVariantRow from './ProductDetailVariantRow';

export interface ProductDetailVariantsProps extends StandardDivProps<ProductDetailVariantsClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailVariantsClassKey = 'root' | 'itemRow';

const themeSettings = { name: 'ProductDetailVariants' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<ProductDetailVariantsClassKey, {}>({
      root: {
        gridArea: 'variants',
      },
      itemRow: {
        '&:not(:last-of-type)': {
          borderBottom: '1px solid',
          borderBottomColor: theme.palette.divider,
        },
      },
    }),
  themeSettings,
);

const ProductDetailVariants = React.forwardRef<HTMLDivElement, ProductDetailVariantsProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });

    const variants = product.variants || [product];

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {variants.map((v, idx) => (
          <ProductDetailVariantRow product={v} key={idx.toString()} className={classes.itemRow} />
        ))}
      </div>
    );
  },
);

ProductDetailVariants.displayName = 'ProductDetailVariants';

export default withThemeProps(themeSettings)(ProductDetailVariants);
